import labelIds from 'rde-view-common/locales/labelIds';
import msgIds from 'rde-view-common/locales/MessageIds';
import MessageUtils from 'rde-view-common/scripts/messageUtils';
import StoreUtils from 'rde-view-common/scripts/storeUtils';
import * as functions from 'rde-view-common/scripts/functions';

import Vue from 'vue';

/**
 * vueインスタンスにutilを注入する
 */
export default (context) => {
  // i18n: メッセージ取得
  Vue.prototype.$msg = (msgId, params) => context.app.i18n.t(`messages.${msgId}`, params);
  context.app.$msg = Vue.prototype.$msg;
  // メッセージID Constant
  Vue.prototype.$msgIds = msgIds;
  context.app.$msgIds = Vue.prototype.$msgIds;

  // i18n: ラベル取得
  Vue.prototype.$label = (labelId, params) => context.app.i18n.t(`labels.${labelId}`, params);
  context.app.$label = Vue.prototype.$label;
  // ラベルID Constant
  Vue.prototype.$labelIds = labelIds;
  context.app.$labelIds = Vue.prototype.$labelIds;

  // functions
  Vue.prototype.$$ = functions;
  context.app.$$ = functions;


  // MessageUtilsにstoreをinjection
  MessageUtils.$store = context.app.store;

  // StoreUtilsにstoreをinjection
  StoreUtils.$store = context.app.store;
};
